import React, { useState, useEffect } from "react";

const InputField = ({
  label,
  type = "text",
  id,
  value = "",
  onChange,
  placeholder = "",
  className = "",
  labelClassName = "",
  disabled = false, // Disabled state
  error = "", // Error message
  ...props
}) => {

  return (
    <div className="w-full flex flex-col gap-1">
      {label && (
        <label
          htmlFor={id}
          className={`text-subtitle2 font-ptsans text-secondary/90 font-medium pl-2 block ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <input
        type={type}
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full h-12 text-secondary/90 rounded-xl border-2 pl-4 pr-2 placeholder:text-secondary/60 py-3 text-body1 font-ptsans outline-none hover:!border-secondary/60 focus:!border-secondary/65 focus:!outline-2 focus:outline-secondary/30 ${
          disabled
            ? "bg-background_2/80 border-none text-secondary/90 cursor-not-allowed"
            : "!border-secondary/35 bg-transparent"
        }  ${
          error
            ? "!border-red-500/80 focus:!border-red-500 focus:!outline-red-500/60 hover:!border-red-500/55"
            : ""
        } ${className}`}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />
      {error && <p className="text-red-500 text-xs pl-2">{error}</p>}
    </div>
  );
};

export default InputField;
